import { PREPOPULATE_ADDRESS, REMOVE_PREPOPULATED_ADDRESS } from 'helpers/types';

const INITIAL_STATE = {
  populated: false,
  nickname: '',
  address_line1: '',
  address_line2: '',
  city_town: '',
  county: '',
  postcode: '',
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case PREPOPULATE_ADDRESS:
      return {
        ...state,
        ...action.payload,
        populated: true,
      };
    case REMOVE_PREPOPULATED_ADDRESS:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
}
